import { Routes } from '@angular/router';

export const appRoutes: Routes = [
    { path: '', redirectTo: '/Login', pathMatch: 'full' },
    {
        path: 'Login',
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'Auth',
        loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
    },
    {
        path: 'SSO',
        loadComponent: () => import('./sso/sso.component').then(m => m.SSOComponent),
    },
    {
        path: 'ForgetPassword',
        loadComponent: () => import('./pages/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    },
    {
        path: 'EntityDashboard',
        loadComponent: () => import('./pages/entitydashboard/entitydashboard.component').then(m => m.EntitydashboardComponent),
    },
    {
        path: 'CustomerMaster',
        loadComponent: () => import('./pages/onboard-entity/customer-master/customer-master.component').then(m => m.CustomerMasterComponent),
    },
    {
        path: 'EntityMaster',
        loadComponent: () => import('./pages/onboard-entity/entity-master/entity-master.component').then(m => m.EntityMasterComponent),
    },
    {
        path: 'ActivityCalender',
        loadComponent: () => import('./pages/master-scoping/activity-calender/activity-calender.component').then(m => m.ActivityCalenderComponent),
    },
    {
        path: 'AgreementDetails',
        loadComponent: () => import('./pages/master-scoping/agreement-details-master/agreement-details-master.component').then(m => m.AgreementDetailsMasterComponent),
    },
    {
        path: 'MasterScoping',
        loadComponent: () => import('./pages/master-scoping//master-scoping-setup//master-scoping-setup.component').then(m => m.MasterScopingSetupComponent),
    },
    {
        path: 'CommercialMapping',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping/commercial-mapping.component').then(m => m.CommercialMappingComponent),
    },
    {
        path: 'CommercialMappingGrid',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping-grid/commercial-mapping-grid.component').then(m => m.CommercialMappingGridComponent),
    },
    {
        path: 'ActivityCalender',
        loadComponent: () => import('./pages/master-scoping/activity-calender/activity-calender.component').then(m => m.ActivityCalenderComponent),
    },
    {
        path: 'AgreementDetails',
        loadComponent: () => import('./pages/master-scoping/agreement-details-master/agreement-details-master.component').then(m => m.AgreementDetailsMasterComponent),
    },
    {
        path: 'CommercialMapping',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping/commercial-mapping.component').then(m => m.CommercialMappingComponent),
    },
    {
        path: 'MasterScopingSetup',
        loadComponent: () => import('./pages/master-scoping/master-scoping-setup/master-scoping-setup.component').then(m => m.MasterScopingSetupComponent),
    },
    {
        path: 'AgreementDetail',
        loadComponent: () => import('./pages/master-scoping/agreement-details-master/agreement-details-master.component').then(m => m.AgreementDetailsMasterComponent),
    },
    {
        path: 'EntityMasters',
        loadComponent: () => import('./pages/onboard-entity/entity-master/entity-master.component').then(m => m.EntityMasterComponent),
    },
    {
        path: 'MasterScopings',
        loadComponent: () => import('./pages/master-scoping//master-scoping-setup//master-scoping-setup.component').then(m => m.MasterScopingSetupComponent),
    },
    {
        path: 'CommercialMappings',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping/commercial-mapping.component').then(m => m.CommercialMappingComponent),
    },
    {
        path: 'ActivityCalenders',
        loadComponent: () => import('./pages/master-scoping/activity-calender/activity-calender.component').then(m => m.ActivityCalenderComponent),
    },
    {
        path: 'CustomerMasters',
        loadComponent: () => import('./pages/onboard-entity/customer-master/customer-master.component').then(m => m.CustomerMasterComponent),
    },
    {
        path: 'EntityAddEdit',
        loadComponent: () => import('./pages/popups/add-edit-entity-master/add-edit-entity-master.component').then(m => m.AddEditEntityMasterComponent),
    },
    {
        path: 'CustomerAddEdit',
        loadComponent: () => import('./pages/popups/customer-master-add-edit-popup/customer-master-add-edit-popup.component').then(m => m.CustomerMasterAddEditPopupComponent),
    },
    {
        path: 'EntityBulkUpload',
        loadComponent: () => import('./pages/popups/entity-upload-popup/entity-upload-popup.component').then(m => m.EntityUploadPopupComponent),
    },
    {
        path: 'MasterScopingEdit',
        loadComponent: () => import('./pages/master-scoping/master-scoping-edit/master-scoping-edit.component').then(m => m.MasterScopingEditComponent),
    },
    {
        path: 'CommercialMappingEdit',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping-edit/commercial-mapping-edit.component').then(m => m.CommercialMappingEditComponent),
    },
    {
        path: 'StateBillingMaster',
        loadComponent: () => import('./pages/master-scoping/state-billing-master/state-billing-master.component').then(m => m.StateBillingMasterComponent),
    },
    {
        path: 'StateBillingMasterEdit',
        loadComponent: () => import('./pages/master-scoping/state-billing-master-edit/state-billing-master-edit.component').then(m => m.StateBillingMasterEditComponent),
    },
    {
        path: 'PO',
        loadComponent: () => import('./pages/master-scoping/po/po.component').then(m => m.POComponent),
    },
    {
        path: 'POAddEdit',
        loadComponent: () => import('./pages/master-scoping/poadd-edit/poadd-edit.component').then(m => m.POAddEditComponent),
    },
        {
        path:'Invoice',
        loadComponent: () => import('./pages/master-scoping/recurring-invoicing/recurring-invoicing.component').then(m => m.RecurringInvoicingComponent),
    },
    {
        path: 'Reports',
        loadComponent: () => import('./pages/master-scoping/invoice-generation/invoice-generation.component').then(m => m.InvoiceGenerationComponent),
    },
    {
        path: 'Error/:code',
        loadComponent: () => import('./pages/ErrorPages/error-page/error-page.component').then(m => m.ErrorPageComponent),
    },
    {
        path: '**',
        redirectTo: '/Error/404.',
    },
];
